module.exports = __webpack_public_path__ + "img/CSS.4aeed59b.svg";